import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import logo from "../../images/logo.jpg";
import { useTranslation } from "react-i18next";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import useStore from "../../State";
import { useSnackbar } from "notistack";
import { darkColor, isDev } from "../costant";
import { findPermissions, login } from "../../endpoints/api";

const Login: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const setLoggedIn = useStore((state: any) => state.setLoggedIn);
  const setUser = useStore((state: any) => state.setUser);

  document.body.style.backgroundColor = darkColor;
  const [heigth, setHeigth] = useState<number>(window.innerHeight);
  useEffect(() => {
    window.addEventListener("resize", () => setHeigth(window.innerHeight));
    return () =>
      window.removeEventListener("resize", () => setHeigth(window.innerHeight));
  }, []);

  useEffect(() => {
    setLoggedIn(false);
  }, []);

  const [name, setName] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  return (
    <Grid container height={heigth} justifyContent="center" alignItems="center">
      <Grid item xs={9}>
        <Card style={{ padding: "32px" }}>
          <Grid container alignItems="center">
            <Grid item xs={4}>
              <img src={logo} alt="logo" style={{ width: "90%" }} />
            </Grid>
            <Grid item container xs={8} flexDirection="column" spacing={2}>
              <Grid item>
                <Typography variant="h3">{t("welcomeBack")}</Typography>
              </Grid>
              <Grid item>
                <TextField
                  label={t("email")}
                  variant="outlined"
                  fullWidth
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  label={t("password")}
                  variant="outlined"
                  type={showPassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => {
                    if (isDev) {
                      setLoggedIn(true);
                      setUser({
                        name: "test-zerynth",
                        password: "test-zerynth",
                        admin: true,
                      });
                      navigate("/home");
                    } else {
                      login(name, password).then((res) => {
                        if (res && res.message === "Logged in") {
                          console.log("RES LOGIN", res);
                          setLoggedIn(true);
                          findPermissions().then((result) => {
                            console.log("RES PERMISSION", result);
                            const tmp = ((result as any[]) || []).filter(
                              (r) => r.email === name
                            );
                            if (tmp.length > 0) {
                              setUser({
                                name: name,
                                password: password,
                                admin: tmp[0].role === "Admin" ? true : false,
                              });
                            } else {
                              setUser({
                                name: name,
                                password: password,
                                admin: false,
                              });
                            }
                            navigate("/home");
                          });
                        } else {
                          enqueueSnackbar(t("loginError"), {
                            variant: "error",
                          });
                        }
                      });
                    }
                  }}
                >
                  {t("login")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Login;
